/**
 * Promo Stepper Component
 * 
 * Displays the step indicator for promo creation process:
 * Step 1: Basic Information
 * Step 2: Discount Config
 * Step 3: Targeting
 * Step 4: Eligibility & Conditions
 * Step 5: Stackability Rules
 * Step 6: Summary
 */

import React from 'react';
import { PromoStepConfig } from '../../../../../api/promos/types';
import '../../../../../Common/Stepper/Stepper.css';

interface PromoStepperProps {
  steps: PromoStepConfig[];
  currentStep: number;
  onStepClick: (stepIndex: number) => void;
}

const PromoStepper: React.FC<PromoStepperProps> = ({
  steps,
  currentStep,
  onStepClick,
}) => {
  return (
    <div className="stepper-container">
      <div className="stepper-wrapper">
        {steps.map((step, index) => {
          const isActive = index === currentStep;
          const isCompleted = step.isCompleted;
          const isPending = !isActive && !isCompleted;
          
          return (
            <React.Fragment key={step.id}>
              <div 
                className={`stepper-item ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''} ${isPending ? 'pending' : ''}`}
              >
                {/* Step Circle */}
                <div 
                  className={`stepper-circle ${
                    isActive ? 'active' : ''
                  } ${
                    isCompleted ? 'completed' : ''
                  } ${
                    index <= currentStep ? 'clickable' : ''
                  }`}
                  onClick={() => {
                    // Allow clicking on previous steps or current step
                    if (index <= currentStep) {
                      onStepClick(index);
                    }
                  }}
                >
                  {isCompleted ? (
                    <i className="ph-check" style={{ fontSize: '12px' }}></i>
                  ) : (
                    <span className="stepper-number">{index + 1}</span>
                  )}
                </div>
                
                {/* Step Label */}
                <div className="stepper-label">
                  <span className={`stepper-title ${
                    isActive ? 'active' : ''
                  } ${
                    isCompleted ? 'completed' : ''
                  }`}>
                    {step.title}
                    {step.isOptional && (
                      <span className="optional-text" style={{ marginLeft: '4px' }}>
                        (Optional)
                      </span>
                    )}
                  </span>
                </div>
              </div>
              
              {/* Progress Line */}
              {index < steps.length - 1 && (
                <div 
                  className={`stepper-line ${
                    isCompleted ? 'completed' : ''
                  }`}
                ></div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default PromoStepper;
